module.exports = __webpack_public_path__ + "graphics/platform-roblox.ckh.cd8f077718ea5a0c7dd157b2f318dd07.png";